import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/auth';

const Children = () => {
  const { user } = useAuth();
  const [children, setChildren] = useState([]);
  const [selectedChild, setSelectedChild] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchChildren();
  }, []);

  const fetchChildren = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/parent/children', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setChildren(response.data);
      if (response.data.length > 0) {
        setSelectedChild(response.data[0]);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const getAverageColor = (average) => {
    if (average >= 16) return 'text-green-600';
    if (average >= 12) return 'text-blue-600';
    if (average >= 10) return 'text-yellow-600';
    return 'text-red-600';
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-[#2C3E50]">👧 Mes enfants</h1>

      {loading ? (
        <div className="text-center py-8">Chargement...</div>
      ) : children.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-8 text-center">
          <p className="text-gray-500">Aucun enfant enregistré</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {children.map((child) => (
            <div
              key={child.id}
              onClick={() => setSelectedChild(child)}
              className={`bg-white rounded-xl shadow-md p-6 cursor-pointer transition ${
                selectedChild?.id === child.id
                  ? 'border-2 border-[#E67E22]'
                  : 'hover:shadow-lg'
              }`}
            >
              <div className="flex items-center space-x-3">
                <span className="text-3xl">👧</span>
                <div>
                  <h3 className="font-bold text-[#2C3E50]">{child.name}</h3>
                  <p className="text-sm text-gray-500">{child.class_name}</p>
                </div>
              </div>
              <div className="mt-3 grid grid-cols-2 gap-2">
                <div>
                  <p className="text-xs text-gray-500">Moyenne</p>
                  <p className={`text-lg font-bold ${getAverageColor(child.average)}`}>
                    {child.average || '-'}/20
                  </p>
                </div>
                <div>
                  <p className="text-xs text-gray-500">Présence</p>
                  <p className="text-lg font-bold text-[#2C3E50]">{child.attendance || '-'}%</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Détails de l'enfant sélectionné */}
      {selectedChild && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-bold text-[#2C3E50] mb-4">
            📊 {selectedChild.name} - {selectedChild.class_name}
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500">Moyenne générale</p>
              <p className={`text-2xl font-bold ${getAverageColor(selectedChild.average)}`}>
                {selectedChild.average || '-'}/20
              </p>
            </div>
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500">Rang</p>
              <p className="text-2xl font-bold text-[#2C3E50]">{selectedChild.rank || '-'}</p>
            </div>
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500">Absences</p>
              <p className="text-2xl font-bold text-red-600">{selectedChild.absences || 0}</p>
            </div>
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-500">Retards</p>
              <p className="text-2xl font-bold text-orange-600">{selectedChild.lates || 0}</p>
            </div>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            <a href={`/parent/children/${selectedChild.id}/grades`} className="btn-primary text-sm">
              📊 Voir les notes
            </a>
            <a href={`/parent/children/${selectedChild.id}/absences`} className="bg-red-100 text-red-700 px-4 py-2 rounded-lg text-sm hover:bg-red-200 transition">
              📅 Absences
            </a>
            <a href={`/parent/children/${selectedChild.id}/compositions`} className="bg-orange-100 text-[#E67E22] px-4 py-2 rounded-lg text-sm hover:bg-orange-200 transition">
              🧪 Compositions
            </a>
            <a href={`/parent/children/${selectedChild.id}/bulletins`} className="bg-purple-100 text-purple-700 px-4 py-2 rounded-lg text-sm hover:bg-purple-200 transition">
              📄 Bulletins
            </a>
            <a href={`/parent/children/${selectedChild.id}/payments`} className="bg-green-100 text-green-700 px-4 py-2 rounded-lg text-sm hover:bg-green-200 transition">
              💰 Paiements
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Children;